import { createStore } from 'vuex'

const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';
var UNIT = 'juvJr4T244WcodnRk';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url: {
      URL_APP_SIMPEG: URL_SIMPEG, 
      URL_APP: URL,
      URL_SLIDER: URL + 'api/v1/publish_inspektorat_slider/',
      URL_BERITA: URL + 'api/v1/web_publish_berita/',
      URL_SAMBUTAN: URL + 'api/v1/publish_inspektorat_sambutan/',
      URL_TENTANG: URL + 'api/v1/publish_inspektorat_tentang/',
      URL_DATA_PEGAWAI: URL + 'api/v1/publish_inspektorat_data_pegawai/',
      URL_LINK_TERKAIT: URL + 'api/v1/web_publish_link_terkait/',
      URL_FOTO: URL + 'api/v1/publish_inspektorat_foto/',
      URL_TUJUAN_SASARAN: URL + 'api/v1/publish_inspektorat_tujuan_sasaran/',
      URL_PRODUK_HUKUM: URL + 'api/v1/publish_inspektorat_produk_hukum/',
      URL_SEJARAH: URL + 'api/v1/publish_inspektorat_sejarah/',
      URL_TUGAS_POKOK: URL + 'api/v1/publish_inspektorat_tugas_pokok/',
      URL_VISI_MISI: URL + 'api/v1/publish_inspektorat_visi_misi/',
      URL_STRUKTUR_ORGANISASI: URL + 'api/v1/publish_inspektorat_struktur_organisasi/',
      URL_UNIT_KERJA: URL + 'api/v1/publish_inspektorat_unit_kerja/',
      URL_REVIU_DAK: URL + 'api/v1/publish_inspektorat_r_dak/',
      URL_REVIU_RKA: URL + 'api/v1/publish_inspektorat_r_rka/',
      URL_REVIU_PAPBJ: URL + 'api/v1/publish_inspektorat_r_papbj/',
      URL_LHKPN: URL + 'api/v1/publish_inspektorat_lhkpn/',
      URL_PMPRB: URL + 'api/v1/publish_inspektorat_pmprb/',
      URL_RADPK: URL + 'api/v1/publish_inspektorat_radpk/',
      URL_SABER_PUNGLI: URL + 'api/v1/publish_inspektorat_saber_pungli/',
      URL_SPIP: URL + 'api/v1/publish_inspektorat_spip/',
      URL_TP4D: URL + 'api/v1/publish_inspektorat_tp4d/',
      URL_UPG: URL + 'api/v1/publish_inspektorat_upg/',
      URL_WBS: URL + 'api/v1/publish_inspektorat_wbs/',
      URL_ZONA_INTEGRITAS: URL + 'api/v1/publish_inspektorat_zi_wbk_wbbm/',
      URL_VIDEO: URL + 'api/v1/publish_inspektorat_video/',
      URL_EVENT: URL + 'api/v1/publish_inspektorat_event/',
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
